export default __webpack_public_path__ + "static/media/bar-obu.f276f4f7.svg";